import AccordionAccountholder from 'practice/components/detail/form/accordion-accountholder';
import AccordionApplicant from 'practice/components/detail/form/accordion-applicant';
import AccordionExceptionList from 'practice/components/detail/form/accordion-exception-list';
import AccordionInterestedPeople from 'practice/components/detail/form/accordion-interested-people';
import AccordionPractice from 'practice/components/detail/form/accordion-practice';
import AccordionPracticeState from 'practice/components/detail/form/accordion-practice-state';
import ActiveStep from 'practice/components/detail/form/active-step';
import { PracticeDetailVM } from 'practice/view-models/practice-detail';
import { Fragment, memo, ReactElement } from 'react';
import { PracticeData } from 'shell/models/practice';

interface FormDetailProps {
  step?: number;
  isDetail?: boolean;
  redirectUriHistory?: boolean;
  loadViewMessi: () => Promise<void>;
  loadUpdateDate: () => Promise<PracticeDetailVM> | void;
  tipoIniziativa?: string;
  noteMesso?: string;
  practiceData?: PracticeDetailVM;
  datiMesso?: PracticeData;
}

const FormDetailComponentIsUnAvailabilty = ({
  step,
  isDetail,
  redirectUriHistory,
  loadViewMessi,
  loadUpdateDate,
  tipoIniziativa,
  noteMesso,
  practiceData,
}: FormDetailProps): ReactElement => {
  return (
    <Fragment>
      <AccordionPractice disabled isDetail={isDetail} />
      <AccordionExceptionList />
      {!redirectUriHistory ? <AccordionApplicant disabled /> : <></>}
      <AccordionAccountholder disabled />
      <AccordionPracticeState disabled />
      <AccordionInterestedPeople disabled={isDetail} />
      <ActiveStep
        step={step}
        disabled={isDetail}
        loadViewMessi={loadViewMessi}
        loadUpdateDate={loadUpdateDate}
        isUnavailability
        tipoIniziativa={tipoIniziativa}
        noteMesso={noteMesso}
        practiceData={practiceData}
      />
    </Fragment>
  );
};

FormDetailComponentIsUnAvailabilty.displayName = 'Practice Detail - Form component';

const FormDetailIsUnAvailability = memo(FormDetailComponentIsUnAvailabilty);

export default FormDetailIsUnAvailability;
